import script from "./unsaved-changes-alert.vue?vue&type=script&setup=true&lang=ts"
export * from "./unsaved-changes-alert.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__